import { DatabaseFieldType } from '@databases/types/database';
import { getNumberDisplayString } from '@databases/utils/database/field-types/number';
import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';
import styled from 'styled-components';

import { ViewComponentProps } from './types';

const FormattedNumber = styled.div`
  text-align: right;
`;

const NumberValueView: FunctionComponent<
  ViewComponentProps<DatabaseFieldType.NUMBER>
> = ({ field, value }) => {
  const { locale } = useIntl();

  const formatted = value !== '' ? getNumberDisplayString(value, field, locale) : '';

  return <FormattedNumber>{formatted}</FormattedNumber>;
};

export default NumberValueView;
